import React, { Component, Suspense } from 'react';
import "./css/bootstrap.min.css";
import "./css/style.css";
import "./css/responsive.css";
import './css/newStyle.css'
import { connect } from 'react-redux'

import { get_json ,imagePath} from './common';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Gallery from './Gallery';
import Blog from './Blog';
import Collection from './Collection';
import All_collection from './All_collection';
import Product from './Product';
import Loader from './Loader'
import { useImage } from 'react-image'

 import { Helmet } from "react-helmet";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = { data: [], loader: true, menuOpen: false };
	}
	async componentDidMount() {
		
		await get_json(this)
		await this.props.setresponseJson(this.state.data)
		console.log(this.state.data,"this.state.data")
		setTimeout(function () { this.setState({ loader: false }); }.bind(this), 1000);
		if(this.state.data!=="invalid"){if (this.state.data !== ''|| this.state.data!=="invalid" || this.state.data !== undefined || this.state.data !== null) {
			localStorage.setItem('dataSource', JSON.stringify(this.state.data));
			this.setState({ phone: this.state.data.phone, email: this.state.data.email, logo_image: this.state.data.logo_image, site_title: this.state.data.site_title });
			// localStorage.setItem('phone', JSON.stringify(this.state.data.phone));
			// localStorage.setItem('email', JSON.stringify(this.state.data.email));
			// localStorage.setItem('location', JSON.stringify(this.state.data.location));
		}
		window.addEventListener('scroll', async(event) => {
			var scrollpos = window.scrollY;

			var max_scrollpos = 130
			var class_name = '';
			if (scrollpos > max_scrollpos) {
				document.body.classList.add("darktheme");
				class_name = 'sticked';
			} else {
				class_name = '';
				document.body.classList.remove("darktheme");
			}
		await	this.setState({
				activeClass: class_name
			})
		});
		let Socialicons = [];
		if (typeof this.state.data.social_json !== 'undefined') {
			let social = JSON.parse(this.state.data.social_json);
			if (Object.keys(social).length > 0) {
				social.forEach((item, i) => {
					if (item.type === 'facebook') {
						var icon = 'fa fa-facebook';
					} else if (item.type === 'twitter') {
						icon = 'fa fa-twitter';
					} else if (item.type === 'instagram') {
						icon = 'fa fa-instagram';
					} else if (item.type === 'linkedin') {
						icon = 'fa fa-linkedin';
					}
					Socialicons.push(
						<li key={i}><a href={item.url} target="_blank" rel='noreferrer noopener'>
							<div className="back"><i className={`${icon}`} aria-hidden="true"></i></div>
						</a></li>
					);
				});
				this.setState({ Socialicons: Socialicons });
				localStorage.setItem('Socialicons', JSON.stringify(this.state.Socialicons));
			}
		}
		let menu_item = [];
		let items = [];
		let header = this.state.data.header;
		console.log( this.state.data.header," this.state.data.header;")
		if (typeof header !== 'undefined') {
			if (header.length > 0) {
				header.forEach((item, i) => {
					if (item.page_link === 'Home') {
						var link = '/';
					} else if (item.page_link === 'Gallery') {
						link = '/gallery';
					} else if (item.page_link === 'Blog') {
						link = '/blog';
					} else if (item.page_link === 'About') {
						link = '/about';
					} else if (item.page_link === 'Contact') {
						link = '/contact';
					}
					menu_item.push(
						<li className="menu__item" key={i}>
							<Link to={`${link}`} className="dropdown-toggle menu__link" onClick={() => { document.body.classList.remove('navShowedfixed'); this.setState({ menuOpen: false }) }}>{item.page_title}</Link>
						</li>
					);
				});
				this.setState({ menu_item: menu_item });
			}
		}}
	}
	render() {
		return (

			<Router>
				{this.state.site_title&&<Helmet>
					<title>{this.state.site_title}</title>
				</Helmet>}
				{ (this.state.loader || this.state.data === null) ?
					<Loader></Loader>
					:
					<>
						{this.state.data=="invalid"?
						<div className={'wrong'}>
						<h1>Sorry, something went wrong.</h1></div>
						:<div className={`header ${this.state.menuOpen ? "navShowed" : ""}`}>
							<div className={`header-bot w-left  ${this.state.activeClass}`}>
								<div className="top-bar">
									<div className="container">
										<ul className="top-bar-ul">
											<li><a href="mailto:info@example.com">Free shipping on india</a></li>
										</ul>
									</div>
								</div>
								<div className="container header_middle">
									<div className="row">
										<div className="navIcon flex-50 visible-x">
											<div className="navIcon-i" onClick={() => {
												if (this.state.menuOpen) { document.body.classList.remove('navShowedfixed') } else {
													document.body.classList.add('navShowedfixed')
												}; this.setState({ menuOpen: !this.state.menuOpen })
											}}>
												<span className="line" />
												<span className="line" />
												<span className="line" />
											</div>
										</div>
										<div className="header-bot-inner">
											<div className="logo_agile f-left">
												<Link to='/'>
													{this.state.logo_image !== "" ? <img className="logo_image" src={imagePath+this.state.logo_image} alt="Awesome" /> : <p>{this.state.site_title}</p>}
												</Link>
											</div>
										</div>
										<div className="ban-top">
											<div className="top_nav_left">
												<div className="navbar navbar-default">
													<div className="container-fluid">
														<div className="navbar-header"><button type="button" className="navbar-toggle"><span className="sr-only">Toggle navigation</span><span className="icon-bar" /><span className="icon-bar" /><span className="icon-bar" /></button></div>
														<div className="navbar-collapse menu--shylock">
															<ul className="nav navbar-nav menu__list">
																{this.state.menu_item}
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="headerSocial">
											<ul className="social-nav footer-social">

												<li className="share"></li>
												{this.state.Socialicons}

											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>}

						<Switch>
							<Route exact path='/' component={Home} />
							<Route exact path='/about' component={About} />
							<Route exact path='/contact' component={Contact} />
							<Route exact path='/gallery' component={Gallery} />
							<Route exact path='/blog' component={Blog} />
							<Route exact path='/:Collection' component={Collection} />
							<Route exact path='/:Collection/:All_collection' component={All_collection} />
							<Route exact path='/:Collection/:All_collection/product/:id' component={Product} />
						</Switch>
					</>
				}
			</Router>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		alldata: state.responseJson,
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		setresponseJson: (data) => dispatch({ type: "ALL_RESPONSE", payload: data }),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
// export default App;

